import { render } from "./SuperficieEvent.vue?vue&type=template&id=10bcb036&scoped=true"
import script from "./SuperficieEvent.vue?vue&type=script&lang=js"
export * from "./SuperficieEvent.vue?vue&type=script&lang=js"

import "./SuperficieEvent.vue?vue&type=style&index=0&id=10bcb036&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bcb036"]])

export default __exports__